import { ENCOURS_START, ENCOURS_END } from '../types/blockdate';



/* export and distribute the action in the container component : ENCOURS_START, ENCOURS_END */

export const encourstartdate = (startDate, ) => {
  return async function (dispatch, getState) {
    function onSuccess(response) {
      dispatch({ type: ENCOURS_START, payload: startDate});
    }
    function onError(error) {
    console.error(error);
    }
    try {
      const response = await { ...startDate };
      onSuccess(response);
    }
    catch (err) {
      onError(err);
    }
  };
};

export const encourenddate = (endDate, ) => {
  return async function (dispatch, getState) {
    function onSuccess(response) {
      dispatch({ type: ENCOURS_END, payload: endDate});
    }
    function onError(error) {
    console.error(error);
    }
    try {
      const response = await { ...endDate };
      onSuccess(response);
    }
    catch (err) {
      onError(err);
    }
  };
};
